import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import VChart from 'vue-echarts';
import { AssetUsageDto } from '@/api';
import dayjs from 'dayjs';

interface ChartUsageProps {
  usageData: AssetUsageDto;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Chart-Usage',
  props: {
  usageData: null
},
  setup(__props) {

const props = __props;


const toFormatedDate = (aTimestampDay: number) => dayjs(aTimestampDay).tz().format('YYYY-MM-DD');

const usagePerPersons = _computed(() => props.usageData.usagePerDatasourceUsers.map(
    (usagePErPerson) => ({
      value: usagePErPerson.countRead,
      name: usagePErPerson.userName,
    }),
  ));

const options = _computed(() => ({
    title: {
      text: `Between ${toFormatedDate(props.usageData.startDay)} and ${toFormatedDate(
        props.usageData.endDay,
      )}`,
    },
    tooltip: {
      trigger: 'item',
      appendToBody: true,
      confine: false,
    },
    series: [
      {
        name: 'Usage per user',
        type: 'pie',
        radius: ['0%', '70%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          },
        },
        labelLine: {
          show: true,
        },
        data: usagePerPersons.value,
      },
    ],
  }));

return { __sfc: true,props, toFormatedDate, usagePerPersons, options, _computed, VChart, AssetUsageDto, dayjs }
}

})